import { INIT } from "./rootTypes";

export const init = (firebaseConfig) => ({
  type: INIT,
  payload: firebaseConfig,
});